export const SettingsActions = {
    SET_CLIENT_EDIT_INPUT: 'domain/settings/set_client_edit_input',
    SET_CLIENT_EDIT_VALIDATE: 'domain/settings/set_client_edit_validate',
    SET_CLIENT_EDIT_FLAG: 'domain/settings/set_client_edit_flag',
    PUT_CLIENT_EDIT: 'domain/settings/put_client_edit',
    POST_DOCUMENTS: 'domain/settings/post_documents',
    SET_SEND_DOCUMENTS_RESULT: 'domain/settings/set_send_documents_result',
    POST_SCHOOL_AUTH_URL: 'domain/settings/post_school_auth_url',
}
